import { Layers, Waypoints } from 'lucide-react'
import { SeoConfigTable, type SeoField } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

const GAP_STATUS: SeoField = {
  name: 'status',
  placeholder: S.status,
  options: [
    { value: 'planned', label: S.gapPlanned },
    { value: 'in_progress', label: S.gapInProgress },
    { value: 'done', label: S.gapDone },
  ],
}

/**
 * A12.15 — Kontent bo'shliqlari. Yopilmagan mavzu + kalit so'z + holat + izoh
 * reyestri. CRUD `/admin/seo/content-gaps` (real seo_config jadval).
 */
export function ContentGapsScreen() {
  return (
    <SeoConfigTable
      screenId="A12.15"
      title={S.contentGaps}
      addLabel={S.addGap}
      path="/admin/seo/content-gaps"
      listKey="gaps"
      searchKeys={['topic', 'keyword']}
      icon={<Layers size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'topic', placeholder: S.topic },
        { name: 'keyword', placeholder: S.keyword },
        GAP_STATUS,
        { name: 'note', placeholder: S.note },
      ]}
      columns={[
        { key: 'topic', header: S.topic, type: 'text' },
        { key: 'keyword', header: S.keyword, type: 'text' },
        { key: 'status', header: S.status, type: 'text' },
        { key: 'note', header: S.note, type: 'longtext' },
      ]}
    />
  )
}

/**
 * A12.16 — Ichki havolalar tahlili. Rejalashtirilgan ichki havola (qayerdan →
 * qayerga + ankor) reyestri. CRUD `/admin/seo/internal-links` (real seo_config).
 */
export function InternalLinksScreen() {
  return (
    <SeoConfigTable
      screenId="A12.16"
      title={S.internalLinks}
      addLabel={S.addLink}
      path="/admin/seo/internal-links"
      listKey="links"
      searchKeys={['from_path', 'to_path']}
      icon={<Waypoints size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'from_path', placeholder: '/from', mono: true },
        { name: 'to_path', placeholder: '/to', mono: true },
        { name: 'anchor', placeholder: S.anchor },
      ]}
      columns={[
        { key: 'from_path', header: S.from, type: 'text' },
        { key: 'to_path', header: S.to, type: 'text' },
        { key: 'anchor', header: S.anchor, type: 'text' },
      ]}
    />
  )
}
